module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n\r\n<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">List Settings</span></div>\r\n\r\n<div class=\"add_overflow_y\">\r\n	<table id=\"propMainTable\"></table> \r\n</div>\r\n\r\n\r\n<div id=\"propMainGridButtons\" class=\"propMainGridButtons\">\r\n	<button type=\"button\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\">\r\n		<i class=\"fa pf-add\" style=\"\"></i>\r\n	</button>\r\n	<button type=\"button\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\">\r\n		<i class=\"fa pf-delete icon-gradient\"></i>\r\n	</button>\r\n	<button type=\"button\" name=\"itemUp\" title=\"up\" class=\"itemUp btn btn-default hvr-glow tbl-icon\">\r\n		<i class=\"fa pf-icon-up pf-carot-down\" aria-expanded=\"true\" style=\"-webkit-transform: rotate(-180deg);\"></i>\r\n	</button>\r\n	<button type=\"button\" name=\"itemDown\" title=\"down\"  class=\"itemDown btn btn-default hvr-glow tbl-icon\" >\r\n		<i class=\"fa pf-carot-down\" aria-expanded=\"true\" style=\"\"></i>\r\n	</button>\r\n\r\n	<button type=\"button\" title=\"Add Predefined List\"  name=\"itemList\" class=\"itemList btn btn-default hvr-glow tbl-icon-lst\" >\r\n		<span class=\"fa fa-list-ul\"></span>\r\n	</button>\r\n<div class=\"prop-sublabel\" style=\"margin-left: 15px;\">\r\n	<input type=\"checkbox\" name=\"allowMultiple\"\r\n		   id=\"allowMultiple\"></input><label for=\"allowMultiple\">&nbsp;Allow multiple selection</label>\r\n</div>\r\n\r\n</div>")
  }
  return __output;

}